import { http } from '@/http'

/**
 * Catálogo UBIGEO y gestión de distritos (DEF-ADM-016).
 * Endpoints admin (JWT); NO son city-scoped.
 */
export default {
  departamentos() {
    return http.get('/api/v1/ubigeo/departamentos')
  },
  provincias(dept) {
    return http.get(`/api/v1/ubigeo/departamentos/${encodeURIComponent(dept)}/provincias`)
  },
  distritos(dept, prov) {
    return http.get(`/api/v1/ubigeo/departamentos/${encodeURIComponent(dept)}/provincias/${encodeURIComponent(prov)}/distritos`)
  },
  // data: { is_active, city_id, force }
  toggle(id, data) {
    return http.put(`/api/v1/ubigeo/distritos/${id}/toggle`, data)
  },
  // data: { city_id, departamento }
  activateAll(prov, data) {
    return http.put(`/api/v1/ubigeo/provincias/${encodeURIComponent(prov)}/activate-all`, data)
  },
  search(q) {
    return http.get('/api/v1/ubigeo/search', { params: { q } })
  }
}
